import React from 'react'
import reportStyles from './PDFReportStyles';    
import { pdf, Document, Text, Page, View, Image } from '@react-pdf/renderer'

const PhysicalGrowthPage = (params) => {
   
  const entity = params.entity;
  const reportParams = params.params;  

  return (

<Page size="A4" style={reportStyles.page}>
    <View style={reportStyles.HeaderContainer}>
        <Image src={process.env.PUBLIC_URL + '/images/GirlShots.jpg'}  style={reportStyles.headerImage}/>                                                 
        <Text style={reportStyles.PageTitle}>Physical Growth & Health Record</Text>                    
    </View>                            
    <View style={reportStyles.CenterContainerStart}>    
        <View style={reportStyles.table}>
            <View style={reportStyles.rowPageSubHeader}>
                <View style={reportStyles.cell50NBLeft}>
                    <Text style={reportStyles.PageSubTitle}>Physical Growth</Text>
                </View>
            </View>                               
            <View style={reportStyles.row}>
                <View style={reportStyles.cell50}>
                    <Text style={reportStyles.PageText}>Percentile (Height):</Text>
                    <View style={reportStyles.table}>
                        <View style={reportStyles.row}>
                            <View style={reportStyles.cell10NBNP}>
                                <Image src={process.env.PUBLIC_URL + '/images/RedCryFace.png'} style={reportStyles.image33Cell}/> 
                            </View>
                            <View style={reportStyles.cell10NBNP}>
                                <Image src={process.env.PUBLIC_URL + '/images/OrangeFace2.png'} style={reportStyles.image33Cell}/> 
                            </View>
                            <View style={reportStyles.cell60NBNP}>
                                <Image src={process.env.PUBLIC_URL + '/images/GreenFace.png'} style={reportStyles.image33Cell}/> 
                            </View>
                            <View style={reportStyles.cell10NBNP}>
                                <Image src={process.env.PUBLIC_URL + '/images/OrangeFace2.png'} style={reportStyles.image33Cell}/> 
                            </View>
                            <View style={reportStyles.cell10NBNP}>
                                <Image src={process.env.PUBLIC_URL + '/images/RedCryFace.png'} style={reportStyles.image33Cell}/> 
                            </View>
                        </View>    
                        <View style={reportStyles.row}>
                            <View style={reportStyles.cellNB}>
                                <Image src={process.env.PUBLIC_URL + '/images/WellnessBar1.png'} style={reportStyles.imageWellnessBarCell}/> 
                            </View>
                        </View>    
                    </View>        
                    <Image src={process.env.PUBLIC_URL + '/images/BlackArrowInd.png'} style={reportStyles.image27x49Cell}/> 
                    <Text style={reportStyles.PageText}>Your child</Text>
                </View>
                <View style={reportStyles.cell50BB}>
                    <Text style={reportStyles.PageText}>Percentile (Width):</Text>
                    <View style={reportStyles.table}>
                        <View style={reportStyles.row}>
                            <View style={reportStyles.cell10NBNP}>
                                <Image src={process.env.PUBLIC_URL + '/images/RedCryFace.png'} style={reportStyles.image33Cell}/> 
                            </View>
                            <View style={reportStyles.cell10NBNP}>
                                <Image src={process.env.PUBLIC_URL + '/images/OrangeFace2.png'} style={reportStyles.image33Cell}/> 
                            </View>
                            <View style={reportStyles.cell60NBNP}>
                                <Image src={process.env.PUBLIC_URL + '/images/GreenFace.png'} style={reportStyles.image33Cell}/> 
                            </View>
                            <View style={reportStyles.cell10NBNP}>
                                <Image src={process.env.PUBLIC_URL + '/images/OrangeFace2.png'} style={reportStyles.image33Cell}/> 
                            </View>
                            <View style={reportStyles.cell10NBNP}>
                                <Image src={process.env.PUBLIC_URL + '/images/RedCryFace.png'} style={reportStyles.image33Cell}/> 
                            </View>
                        </View>    
                        <View style={reportStyles.row}>
                            <View style={reportStyles.cellNB}>
                                <Image src={process.env.PUBLIC_URL + '/images/WellnessBar1.png'} style={reportStyles.imageWellnessBarCell}/> 
                            </View>
                        </View>    
                    </View>        
                    <Image src={process.env.PUBLIC_URL + '/images/BlackArrowInd.png'} style={reportStyles.image27x49Cell}/> 
                    <Text style={reportStyles.PageText}>Your child</Text>
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell33BB}>
                    <Image src={process.env.PUBLIC_URL + '/images/RedBox.png'} style={reportStyles.image22Cell}/> 
                    <Text style={reportStyles.description}>Abnormal</Text>
                </View>
                <View style={reportStyles.cell33BB}>
                    <Image src={process.env.PUBLIC_URL + '/images/OrangeBox.png'} style={reportStyles.image22Cell}/> 
                    <Text style={reportStyles.description}>Normal (watch)</Text>
                </View>
                <View style={reportStyles.cell33BB}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenBox.png'} style={reportStyles.image22Cell}/> 
                    <Text style={reportStyles.description}>Normal</Text>
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell50}>
                    <Text style={reportStyles.PageText}>Health Record:</Text>
                    <Text style={reportStyles.description}>Compared to the average
                            for your child's age and
                            social group
                    </Text>
                    <Text style={reportStyles.PageText}>Susceptibility:</Text>
                    <Text style={reportStyles.description}>Incidents of illness due to infection*</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/Red50Ind.png'} style={reportStyles.imageIndCell}/> 
                    <Text style={reportStyles.PageText}>Hypersensitivity:</Text>
                    <Text style={reportStyles.description}>Incidents of Allergy*</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenMidInd.png'} style={reportStyles.imageIndCell}/> 
                </View>
                <View style={reportStyles.cell50BB}>
                    <Text style={reportStyles.PageSubTitle}>Need for consultation</Text>
                    <Text style={reportStyles.PageText}>Recommended*</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/RedCheck.png'} style={reportStyles.image33Cell}/> 
                </View>
            </View>
        </View>                                   
    </View>                            
    <View style={reportStyles.FooterContainerSmall}>
        <Text style={reportStyles.footer}>*Indicates if it is apparent that a consultation with a Child Nutritionist within a short period of time
            could be useful in improving the physical wellbeing of the child. This is calculated based on the
            answers received in the scan and peer comparisons.

            # Please note that these findings are for informational and educational purposes only. If you feel that
            there might be something wrong with your child's health, please consult a pediatrician immediately.
        </Text>
    </View>                            
    </Page>  

    
  )  
}
  
export default PhysicalGrowthPage